module.exports = __webpack_public_path__ + "static/media/botswana-shipping-map.0ff3dc93.png";